import { ContainerModule, interfaces } from 'inversify';
import { CloudCostsStore, ICloudCostsStore } from './cloudCosts.store';
import { CloudCostsApiService, ICloudCostsApiService } from './services/cloudCostsApi.service';

export const cloudCostsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ICloudCostsApiService.$).to(CloudCostsApiService).inSingletonScope();
  bind(ICloudCostsStore.$).to(CloudCostsStore).inSingletonScope();
});
